import api from './api';
import { user, templates, channels, events } from '../stores';
import { get, set, remove } from 'es-cookie';

async function init () {
  const [ values, current ] = await Promise.all([
    api.request({ path: '/event-values', credentials: true }),
    api.request({ path: '/events', credentials: true })
  ]);
  templates.set(values.templates);
  channels.set(values.channels);
  events.set(current);
}

async function autoLogin () {
  const email = get('email');
  const token = get('token');
  if (!token) return false;
  api.setToken(token);
  try {
    await init();
    user.set({ email });
    return true;
  } catch (e) {
    return false;
  }
}

async function login ({ email, password }) {
  const result = await api.request({
    method: 'post',
    path: '/users/login',
    data: { email, password }
  });
  if (result.error) return { error: result.error };
  api.setToken(result.token);
  await init();
  user.set({ email });
  set('token', result.token, { expires: 0.5 });
}

async function reset ({ email, url }) {
  const result = await api.request({
    method: 'post',
    path: '/users/password-reset',
    data: { email, url }
  });
  return result;
}

async function change ({ email, token, password }) {
  const result = await api.request({
    method: 'post',
    path: '/users/password-change',
    data: { email, recoveryToken: token, newPassword: password }
  });
  if (result.token) {
    api.setToken(result.token);
    await init();
    user.set({ email });
    set('token', result.token, { expires: 0.5 });
  }
  return result;
}

function logout () {
  api.setToken();
  user.set();
  remove('token');
}

export {
  init,
  autoLogin,
  login,
  logout,
  reset,
  change
};
